<p>{{ productNumber | paymentCardNumber : productNumberFormat }}</p>
